import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import "./movieList.scss";
import { SwiperSlide, Swiper } from 'swiper/react';// eslint-disable-next-line
// import { Link } from 'react-router-dom';// eslint-disable-next-line
// import Button from '../button/Button';
// import apiConfig from '../../api/apiConfig';
import axios from 'axios';
import MovieCard from '../movie-card/MovieCard';

const MovieList = props => {
    const [items, setItems] = useState([])
    useEffect(() => {
        const getList = async () => {
            let response = null;

            if (props.type !== 'similar') {
                switch (props.category) {
                    case 'movie':
                        response = await axios.get(`https://api.themoviedb.org/3/movie/${props.type}?api_key=088f4df643022cbbe2a297babd84490c`);
                        break;

                    default:
                        response = await axios.get(`https://api.themoviedb.org/3/tv/${props.type}?api_key=088f4df643022cbbe2a297babd84490c`)
                }
            } else {
                response = await axios.get(`https://api.themoviedb.org/3/${props.category}/${props.id}/similar?api_key=088f4df643022cbbe2a297babd84490c`)
            }
            setItems(response.data.results);
        }
        getList();
    }, [props.category, props.id, props.type]);
    return (
        <div className="movie-list">
            <Swiper
                grabCursor={true}
                spaceBetween={10}
                slidesPerView={'auto'}

            >
                {
                    items.map ((item, index) => (
                        <SwiperSlide key={index}>
                            {/* <img src={apiConfig.w500Image(item.poster_path)} alt="" /> */}
                            <MovieCard item={item} category={props.category} />
                        </SwiperSlide>
                    )) 
                }
            </Swiper>
        </div>
    )
}

MovieList.propTypes = {
    category: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
}

export default MovieList